// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__16jvv","inputDescription":"styles_inputDescription__1gS4c"};